import { shortNumber, longNumber } from "./NumberFormatter"

export const shortCurrency = (number, decimals) => {
  return shortNumber(number, decimals) + '\xa0€'
}

export const longCurrency = (number, decimals) => {
  return longNumber(number, decimals) + '\xa0€'
}
